const get = require('lodash/get');
const addClass = require('../dom/add-class');
const constants = require('./constants');

/**
 * Localize an HTML element. Uses the provided attributes to update the
 * contents of the element with the correct localized value.
 *
 * @param  {Object} element    HTML element
 * @param  {Object} attributes Flow HTML attributes from calling getAttributes(element)
 * @param  {Object} data       The data to use for looking up localized value
 *                             referenced by the `flow-selector` attribute
 */
function localizeElement(element, attributes, data) {
  const label = get(data, attributes.selector);

  if (label) {
    element.innerHTML = `${attributes.prefix || ''} ${label} ${attributes.suffix || ''}`.trim(); // eslint-disable-line no-param-reassign
    addClass(element, constants.FLOW_LOCALIZED_CLASS);
  } else if (attributes.default) {
    element.innerHTML = `${attributes.prefix || ''} ${attributes.default} ${attributes.suffix || ''}`.trim(); // eslint-disable-line no-param-reassign
    addClass(element, constants.FLOW_LOCALIZED_CLASS);
  } else if (!element.innerHTML) {
    element.innerHTML = ''; // eslint-disable-line no-param-reassign
  }

  return element;
}

module.exports = localizeElement;



// WEBPACK FOOTER //
// ./static/js/v0/utilities/tags/localize-element.js